<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.sellingPriceDetail')"
        size="large"
        @close="closeOverSide">
        <div :style="{ minWidth: minWidthScroll }">
            <view-selling-price :data-edit="dataEdit" />
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { IVendorPrice } from './data'
import ViewSellingPrice from './view-selling-price.vue'
import screen from '~/components/utils/screen'

const emits = defineEmits(['refreshTables'])

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const visible = ref(false)
const loading = ref(false)

const dataEdit = ref<IVendorPrice>({
  createPriceFrom: 1,
  quote: null,
  quoteCode: null,
  quoteRequest: null,
  quoteRequestCode: null,
  vendor: null,
  contact: null,
  contactName: '',
  vendorName: '',
  email: null,
  phone: null,
  workflow: null,
  workflowName: '',
  transportation: '',
  contCategory: '',
  vehicleCategory: '',
  effectiveFromDate: null,
  effectiveToDate: null,
  price: null,
  oilPrice: null,
  description: null,
  mergeContainer: false,
  headContainer: false,
  positions: [],
  theSamePositions: [],
  typeCommodity: [],
  vehicleCategoryName: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: ''
    }
  ],
  priceOfflineFee: []
})
const open = (id: string) => {
  if (id) {
    const api = {
      url: '/pp/selling-price/ID',
      method: 'get'
    }

    $api(api, { uriParams: { ID: id || '' } }).then((data) => {
      const resData: any = data?.data?.value

      if (resData.success) {
        const vendorPrice: IVendorPrice = resData.data

        if (vendorPrice.vendor && typeof vendorPrice.vendor !== 'string') {
          vendorPrice.vendorName = vendorPrice.vendor.name
        }

        if (vendorPrice.contact && typeof vendorPrice.contact !== 'string') {
          vendorPrice.email = vendorPrice.contact?.email
          vendorPrice.phone = vendorPrice.contact?.phone
          vendorPrice.contactName = vendorPrice.contact?.fullName
        }

        vendorPrice?.prices?.forEach((price, index) => {
          price.key = index
        })

        dataEdit.value = vendorPrice
        visible.value = true
      }
    })
  }
}

const closeOverSide = () => {
  visible.value = false
}

const selectWorkflow = (workflow: any) => {
  if (Array.isArray(workflow) && workflow.length) {
    if (workflow[0].isCont === true) {
      dataEdit.value.type = 'cont'
      return 'cont'
    }
    if (workflow[0].isCont === false) {
      dataEdit.value.type = 'vehicle'
      return 'vehicle'
    }
  }

  if (workflow?.isCont === true) {
    dataEdit.value.type = 'cont'
    return 'cont'
  }
  if (workflow?.isCont === false) {
    dataEdit.value.type = 'vehicle'
    return 'vehicle'
  }
  dataEdit.value.type = ''
  return ''
}

defineExpose({ open })
</script>
